<div>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <p class="m-0">Price</p>
    <button mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-nav-list>
    <a *ngFor="let idx of priceArray" mat-list-item (click)="openLink(idx)">
      <span mat-line>{{ idx.name }}</span>
    </a>
  </mat-nav-list>
</div>
